const FilesNameSpace = 'files';

const FilesActionTypes = Object.freeze({
    GetFiles: 'GetFiles',
    AddFile: 'AddFile',
});

const FilesMutationTypes = Object.freeze({
    SetFiles: 'SetFiles',
});

const FilesGetterTypes = Object.freeze({
    GetFiles: 'GetFiles',
});

export {
    FilesNameSpace,
    FilesActionTypes,
    FilesMutationTypes,
    FilesGetterTypes,
};